import React from "react";
import { ReduxProvider } from "../store/redux-store-config";
import { BrowserRouter } from "react-router-dom";
import { PageVisitedProvider } from "./Welcome";
import { WorkSpace } from "./WorkSpace";
import { createGlobalStyle } from "styled-components";

// import "@uitk/foundations/Brand_optum/fonts.css";
// import "@uitk/foundations/Brand_uhc/fonts.css";
// import { optum } from "@uitk/foundations";

// import { Toolkit } from "@uitk/react";

import { Toolkit } from "@uitk/react";
import { optum } from "@uitk/foundations";
import ReactDOM from "react-dom/client";

const appId = "OPTUM_ICP_DASHBOARD";

const GlobalStyles = createGlobalStyle`
  html, body { font-family: Arial !important; overflow:hidden}
  html, body, #react-root { height: 100%;}
  h1 {
    color: #002677;
    font-size: 24px;
  }
  .textAlignCenter {
    text-align: center;
  }
  .uitk-card__content {
    padding: 8px !important;
}
.templateContainer {
    height: calc(100vh - 218px);
    overflow: hidden;
}
.uitk-panel-header {
  padding: 0px!important;
}
.footerStyles {
  min-height: 4rem !important;
  text-align: center;
  padding: 8px !important;
}
.allowScroll {
  overflow: scroll visible;
  max-height: 380px;
}
.mainContainer{
  height: calc(100vh - 260px) !important;
  overflow: scroll;
}

.pt-b > div {
  max-height: 67vh;
}

footer > div {
  flex-direction: column !important;
  display:none !important;
}

.margingRight16 {
  margin-right: 16px;
}

`;

export function App() {
  return (
    <ReduxProvider>
      <BrowserRouter basename="/ermui/">
        <PageVisitedProvider>
          <GlobalStyles />
          <Toolkit appId={appId} grid spacing theme={optum}>
            <WorkSpace />
          </Toolkit>
        </PageVisitedProvider>
      </BrowserRouter>
    </ReduxProvider>
  );
}
